// libs/core/shell/src/lib/shell.module.ts
import { TooltipModule } from './../../../../components/tooltips/src/lib/tooltip.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ShellLayoutComponent } from './layout/public/shell-layout/shell-layout.component';
import { RouterModule } from '@angular/router';
import { ShellHeaderComponent } from './layout/public/shell-header/shell-header.component';
import { ShellFooterComponent } from './layout/public/shell-footer/shell-footer.component';
import { DrawerModule } from '@cardapio-online/drawer';
import { ShellLayoutAdminComponent } from './layout/admin/shell-layout-admin/shell-layout-admin.component';
import { ShellAdminSidebarComponent } from './layout/admin/shell-admin-sidebar/shell-admin-sidebar.component';
import { ShellAdminToolbarComponent } from './layout/admin/shell-admin-toolbar/shell-admin-toolbar.component';
import { FormsModule } from '@angular/forms';
import { ShellAdminSectionComponent } from './layout/admin/shell-admin-section/shell-admin-section.component';
import { SectionShellFormComponent } from './layout/admin/section-shell-form/section-shell-form.component';
import { UiCartComponent } from './layout/public/ui-cart/ui-cart.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ShellAdminHeaderComponent } from './layout/admin/components/shell-admin-header/shell-admin-header.component';
import { BreadcrumbModule } from '@cardapio-online/breadcrumb';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { HeroHeaderComponent } from './layout/public/hero/hero-header/hero-header.component';
import { HeroCardComponent } from './layout/public/hero/hero-card/hero-card.component';
import { ModalModule} from '@cardapio-online/modal'
import { ClientAuthUiModule, ClientsModule } from '@cardapio-online/clients';
import { MascotModule } from '@cardapio-online/mascot';
import { NotificationsUiModule } from '@cardapio-online/notifications-ui';
import { SnackbarModule } from '@cardapio-online/snackbar';
@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    DrawerModule,
    FormsModule,
    TooltipModule,
    DragDropModule,
    BreadcrumbModule,
    ModalModule,
    ClientsModule,
    ClientAuthUiModule,
    MascotModule,
    NotificationsUiModule,
    SnackbarModule,
  ],
  declarations: [
    ShellLayoutComponent,
    ShellHeaderComponent,
    ShellFooterComponent,
    UiCartComponent,

    ShellLayoutAdminComponent,
    ShellAdminSidebarComponent,
    ShellAdminToolbarComponent,
    ShellAdminSectionComponent,
    SectionShellFormComponent,
    ShellAdminHeaderComponent,
    NotFoundComponent,
    HeroHeaderComponent,
    HeroCardComponent,
  ],
  exports: [
    ShellLayoutComponent,
    ShellHeaderComponent,
    ShellFooterComponent,
    UiCartComponent,
    ShellLayoutAdminComponent,
    ShellAdminSidebarComponent,
    ShellAdminToolbarComponent,
    ShellAdminSectionComponent,
    SectionShellFormComponent,
    ShellAdminHeaderComponent,
    NotFoundComponent,
    HeroHeaderComponent,
    HeroCardComponent,
  ],
})
export class ShellModule {}
